module.exports = __webpack_public_path__ + "static/scale-model-of-hirshfeld-house-in-austin-texas-26c4f7a1c3472b4b9d63728104dff31c.png";